(function () {
    var sections = document.querySelectorAll(".fade-out-scroll-js");
    if (sections.length) {
        var clamp_1 = function (num, min, max) {
            return Math.max(min, Math.min(num, max));
        };
        var animate_1 = function () {
            var pixels = window.pageYOffset;
            sections.forEach(function (section) {
                var topSection = section.offsetTop;
                var midSection = topSection + (section.offsetHeight / 2);
                if (section.offsetTop < pixels) {
                    var opacity = 1;
                    var timeline = clamp_1((pixels + midSection) * 0.002, 0, 1);
                    // fade out
                    timeline -= clamp_1((pixels - (midSection - (window.innerHeight * 0.4))) * 0.002, 0, 1);
                    opacity = timeline;
                    section.style.opacity = opacity.toString();
                }
            });
        };
        animate_1();
        window.addEventListener("scroll", function () {
            animate_1();
        });
    }
})();
